import React, { useState, useEffect, useId } from "react";
import { connect } from "react-redux";
import { getBillingJointRequest } from "../../actions";
import Loading from "../../components/Loading";
import { downloadReport, requests } from "../../axios";
import { getStorage } from "../../utils";
import {
  JOINTS_NOT_FOUND,
  JOINTS_APARTMENTS_NOT_FOUND,
  USERDATA,
  JOINT_INPUT_LABEL,
  JOINT_INPUT_DEFAULT_OPTION,
  APARTMENT_LABEL,
  APARTMENT_INPUT_DEFAULT_OPTION,
  REPORT_GENERATION_FAILED,
  JOINTS_INFO_NOT_FOUND,
} from "../../types";
import "../../assets/styles/TaxCertificate.css";
import { useFormik } from "formik";

const TaxCertificate = (props) => {
  const id = useId();

  const [requestState, setRequestState] = useState({
    loading: true,
    error: null,
  });

  const [apartmentState, setApartmentState] = useState({
    apartments: {},
  });

  const [yearState, setYearState] = useState({
    years: {},
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    try {
      if (!props.billingJoints.length) {
        const response = await requests.users.getUsersBillingJoints(
          props.user.userId || getStorage(USERDATA).userId,
        );
        props.getBillingJointRequest(response.data);
      }
      setRequestState({ ...requestState, loading: false });
    } catch (error) {
      console.log(error);
      setRequestState({
        loading: false,
        error: JOINTS_NOT_FOUND,
      });
    }
  };

  const handleInformation = async () => {
    await handleApartments();
    await handleYear();
  }

  const handleApartments = async () => {
    setApartmentState({ apartments: {} });
    setRequestState({ ...requestState, error: null });
    formik.setFieldValue("apartmentId", "");
    const jointId = document.getElementById("joint").value;
    formik.setFieldValue("jointId", jointId);

    try {
      const response = await requests.joints.getBillingApartments(jointId);
      setApartmentState({ apartments: response.data });
    } catch (error) {
      console.log(error);
      setRequestState({
        ...requestState,
        error: JOINTS_APARTMENTS_NOT_FOUND,
      });
    }
  };

  const handleYear = async () => {
    setRequestState({ ...requestState, error: null });
    const jointId = document.getElementById("joint").value;
    formik.setFieldValue("jointId", jointId);
    formik.setFieldValue("year", "");
    try {
      const response = await requests.cashReceipts.getYearsByJointId(jointId);
      setYearState({ years: response.data });
    } catch (error) {
      console.log(error);
      setRequestState({
        ...requestState,
        error: JOINTS_INFO_NOT_FOUND,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      jointId: "",
      apartmentId: "",
      documentType: "",
      documentNumber: "",
      parkingId: "",
      utilityRoomId: "",
      year: new Date().getFullYear() - 1,
    },
    onSubmit: async (values) => {
      setRequestState({ ...requestState, loading: true });
      try {
        const reportData = {
          administrator: props.user.name,
          documentType: values.documentType,
          documentNumber: values.documentNumber,
          parkingId: values.parkingId,
          utilityRoomId: values.utilityRoomId,
        };
        const response = await requests.reports.getTaxCertificateReport(
          values.jointId,
          values.apartmentId,
          values.year,
          reportData,
        );
        downloadReport(
          response.data,
          `Certificado Tributario ${values.year} - ${values.apartmentId}`,
          "pdf",
        );
        formik.resetForm();
        setRequestState({ ...requestState, loading: false });
      } catch (error) {
        console.log(error);
        setRequestState({ loading: false, error: REPORT_GENERATION_FAILED });
      }
    },
  });

  const options =
    props.billingJoints.length &&
    props.billingJoints.map((billing, index) => {
      return (
        <option value={billing.joint.jointId} key={`${id}-${index}`}>
          {billing.joint.jointName}
        </option>
      );
    });

  return (
    <>
      {requestState.loading ? (
        <Loading />
      ) : (
        <section className="userform" role="form">
          <form
            className="square-form tax-certificate-grid"
            onSubmit={formik.handleSubmit}
          >
            <h2 className="tax-certificate-title">Certificado Tributario</h2>
            <h5 className="joint-label">{JOINT_INPUT_LABEL}</h5>
            <select
              className="joint-input userform-select"
              id="joint"
              name="joint"
              data-testid="jointInput"
              value={formik.values.jointId}
              onChange={handleInformation}
              required
            >
              <option value="">{JOINT_INPUT_DEFAULT_OPTION}</option>
              {options}
            </select>
            <h5 className="owner-label">{APARTMENT_LABEL}</h5>
            <select
              className="owner-input userform-select"
              id="apartment"
              name="apartment"
              data-testid="apartmentInput"
              {...formik.getFieldProps("apartmentId")}
              required
            >
              <option value="">{APARTMENT_INPUT_DEFAULT_OPTION}</option>
              {apartmentState.apartments.length &&
                apartmentState.apartments.map((apartment, index) => {
                  return (
                    <option
                      value={apartment.apartmentId}
                      key={`${id}-${index}`}
                    >
                      {`${apartment.apartmentId} - ${apartment.owner}`}
                    </option>
                  );
                })}
            </select>
            <h5 className="document-label">Documento</h5>
            <div className="document-input">
              <select
                className="userform-select tax-certificate-document-type-select"
                name="documentType"
                {...formik.getFieldProps("documentType")}
                required
              >
                <option value="C.C.">C.C.</option>
                <option value="C.E.">C.E.</option>
                <option value="NIT">NIT</option>
                <option value="PA">PA</option>
                <option value="T.I.">T.I.</option>
                <option value="R.C.">R.C.</option>
              </select>
              <input
                className="userform-input-text tax-certificate-document-number-input"
                type="text"
                name="documentNumber"
                {...formik.getFieldProps("documentNumber")}
                required
              />
            </div>
            <h5 className="year-label">Año</h5>
            <select
              className="userform-select tax-certificate-input"
              id="year"
              name="year"
              data-testid="yearInput"
              {...formik.getFieldProps("year")}
              required
            >
              <option value="">Año</option>
              {yearState.years.length &&
                yearState.years.map((year, index) => {
                  return (
                    <option value={year} key={`${id}-${index}`}>
                      {year}
                    </option>
                  );
                })}
            </select>
            <h5 className="parking-label">Parqueadero</h5>
            <input
              className="parking-input userform-input-text tax-certificate-input"
              name="parkingId"
              {...formik.getFieldProps("parkingId")}
              required
            />
            <h5 className="utility-room-label">Cuarto Útil</h5>
            <input
              className="utility-room-input userform-input-text tax-certificate-input"
              name="utilityRoomId"
              {...formik.getFieldProps("utilityRoomId")}
              required
            />
            {requestState.error && (
              <h6 className="bad-request error-message" role="alert">
                {requestState.error}
              </h6>
            )}
            <input
              type="submit"
              className="btn-block btn scaf-accept-btn"
              value="Aceptar"
            ></input>
          </form>
        </section>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    billingJoints: state.billingJoints,
  };
};

const mapDispatchToProps = {
  getBillingJointRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(TaxCertificate);
